export const INSTRUCTION_BUTTON_WIDTH = '280px';
